import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import DispatchAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/DispatchAppIcon';

import DispatchButton from '../OtherComponents/DispatchButton';

const DispatchStrategy = {
  previewInfo: {
    name: 'Dispatch',
    iconSvg: <DispatchAppIcon size="xlarge" />,
    newTab: false,
  },
  headerInfo: {
    name: 'Dispatch',
    category: 'Productivity',
    details: (
      <>
        <Typography variant="body1" paragraph>
          Now, you can receive all your work from enterprise job sources such as home warranty and manufacturers
          automatically inside of Housecall Pro. No more hopping from portal to portal to keep your job sources
          informed. The Dispatch integration will allow you to make updates to your enterprise work directly from the
          Housecall Pro app. Stop hopping between apps and portals, and get more done with less fuss.
        </Typography>
        <Typography variant="body1">
          The integration will have no impact on how you use Housecall Pro today - jobs and leads will simply start
          appearing inside of the Housecall Pro app you use every day.
        </Typography>
      </>
    ),
    iconSvg: <DispatchAppIcon size="xlarge" />,
  },
  price: {
    title: 'Housecall Pro Plan',
    hideToggle: true,
    appActionButton: <DispatchButton />,
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials+ plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  supportContacts: [
    { type: 'Email', contact: 'support@dispatch.me' },
    { type: 'Phone number', contact: '(877) 511-9748' },
  ],
};

export default DispatchStrategy;
